import { useMemo, useState } from "react"

import { buildEmptyPaymentItem } from "~/utils/paymentModalHelpers"

import type PaymentItem from "~/types/PaymentItem"

interface Params {
  initialItems?: PaymentItem[]
  currencyIso?: string
}

const usePaymentItemsState = ({ initialItems, currencyIso }: Params) => {
  const safeCurrencyIso = currencyIso ?? "USD"
  const items = initialItems ?? []

  const initialPaymentItems: PaymentItem[] =
    items.length > 0 ? items : [buildEmptyPaymentItem(safeCurrencyIso)]

  const [paymentItems, setPaymentItems] = useState<PaymentItem[]>(initialPaymentItems)

  const visibleItems = useMemo(() => paymentItems.filter((item) => !item._destroy), [paymentItems])

  const totalCents = useMemo(
    () => visibleItems.reduce((total, item) => total + item.quantity * item.amountCents, 0),
    [visibleItems]
  )

  const hasValidItems = useMemo(
    () => visibleItems.some((item) => !!item.description?.trim() && item.amountCents > 0),
    [visibleItems]
  )

  return {
    paymentItems,
    setPaymentItems,
    visibleItems,
    hasValidItems,
    totalCents,
  }
}

export default usePaymentItemsState
